module.exports = __webpack_public_path__ + "static/media/front.f9b7a38f.png";